"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChildrenButtonWithIconContainer = exports.TextLoaderStyled = exports.IconTextButtonStyled = exports.TextButtonStyled = exports.SubtleButtonStyled = exports.SecondaryButtonStyled = exports.OutlinedWhiteButtonStyled = exports.OutlinedDarkButtonStyled = exports.OutlinedButtonStyled = exports.SolidButtonStyled = exports.PrimaryButtonStyled = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Color_enum_1 = require("../../constants/Color.enum");
const BaseButtonStyled = styled_components_1.default.button `
    width: ${(props) => {
    if (props.iconOnly) {
        return '36px';
    }
    if (props.full) {
        return '100%';
    }
    if (props.size === 'small') {
        return 'auto';
    }
    return '200px';
}};
    padding: ${(props) => {
    if (props.iconOnly) {
        return '0';
    }
    if (props.size === 'small') {
        return '0 12px';
    }
    return '0 24px';
}};
    height: ${(props) => {
    if (props.size === 'small') {
        return '28px';
    }
    if (props.size === 'large') {
        return '48px';
    }
    return props.iconOnly ? '36px' : '40px';
}};
    border-radius: 48px;
    border: 'none';
    cursor: pointer;
    background-color: ${Color_enum_1.Color.Primary};
    color: ${Color_enum_1.Color.Background};
    font-size: ${(props) => {
    if (props.size === 'large') {
        return '14px';
    }
    if (props.size === 'small') {
        return '12px';
    }
    return '12px';
}};
    line-height: ${(props) => {
    if (props.size === 'large') {
        return '28px';
    }
    return '20px';
}};
    letter-spacing: 0.75px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: ${({ disabled, isLoading, blocked }) => (disabled || isLoading || blocked ? 'none' : 'inherit')};
    text-transform: ${({ size }) => (size === 'small' ? 'none' : 'uppercase')};

    &:disabled {
        opacity: 30%;
    }
`;
exports.PrimaryButtonStyled = (0, styled_components_1.default)(BaseButtonStyled) `
    &:hover {
        background-color: ${Color_enum_1.Color.Black};
    }
`;
exports.SolidButtonStyled = (0, styled_components_1.default)(BaseButtonStyled) `
    background-color: ${Color_enum_1.Color.Surface};
    color: ${Color_enum_1.Color.Black};
`;
exports.OutlinedButtonStyled = (0, styled_components_1.default)(BaseButtonStyled) `
    background-color: transparent;
    color: ${Color_enum_1.Color.Surface};
    border: 1px solid ${Color_enum_1.Color.Surface};

    &:hover {
        background-color: ${Color_enum_1.Color.Surface};
        color: ${Color_enum_1.Color.Black};
    }
`;
exports.OutlinedDarkButtonStyled = (0, styled_components_1.default)(BaseButtonStyled) `
    background-color: transparent;
    color: ${Color_enum_1.Color.Surface};
    border: 1px solid ${Color_enum_1.Color.Surface};

    &:hover {
        background-color: ${Color_enum_1.Color.Black};
        color: ${Color_enum_1.Color.Surface};
    }
`;
exports.OutlinedWhiteButtonStyled = (0, styled_components_1.default)(BaseButtonStyled) `
    background-color: ${Color_enum_1.Color.Surface};
    color: ${Color_enum_1.Color.Black};
    border: 1px solid ${Color_enum_1.Color.Surface};

    &:hover {
        background-color: ${Color_enum_1.Color.Black};
        color: ${Color_enum_1.Color.Surface};
    }
`;
exports.SecondaryButtonStyled = (0, styled_components_1.default)(BaseButtonStyled) `
    background-color: ${Color_enum_1.Color.Surface};
    border: 1px solid;
    color: ${Color_enum_1.Color.Primary};
    border-color: ${(props) => (props.iconOnly ? Color_enum_1.Color.Variant_1 : Color_enum_1.Color.Primary)};
    &:hover {
        background-color: ${Color_enum_1.Color.Primary};
        border-color: ${Color_enum_1.Color.Primary};
        color: ${Color_enum_1.Color.Surface};
    }
`;
exports.SubtleButtonStyled = (0, styled_components_1.default)(BaseButtonStyled) `
    background-color: ${Color_enum_1.Color.Surface};
    border: 1px solid ${Color_enum_1.Color.Variant_1};
    color: ${Color_enum_1.Color.Primary};

    &:hover {
        border: 1px solid ${Color_enum_1.Color.Secondary};
    }
`;
exports.TextButtonStyled = (0, styled_components_1.default)(BaseButtonStyled) `
    border: none;
    background-color: transparent;
    width: auto;
    height: 40px;
    padding: 0 30px;
    color: ${(props) => (props.color ? props.color : Color_enum_1.Color.Surface)};

    &:hover {
        color: ${Color_enum_1.Color.Secondary};
    }
`;
exports.IconTextButtonStyled = (0, styled_components_1.default)(exports.TextButtonStyled) `
    text-transform: none;
    justify-content: flex-start;
    color: ${(props) => (props.color ? props.color : Color_enum_1.Color.Primary)};
    padding: 0px;
    height: auto;
    min-height: 20px;
    font-size: 14px;
    font-weight: 500;

    &:hover {
        opacity: 0.5;
        color: ${(props) => (props.color ? props.color : Color_enum_1.Color.Primary)};
    }
`;
exports.TextLoaderStyled = styled_components_1.default.div `
    &:after {
        content: '';
        animation: progress-ellipsis 1s steps(1, end) infinite;
    }

    @keyframes progress-ellipsis {
        0% {
            content: '';
        }
        25% {
            content: '.';
        }
        50% {
            content: '..';
        }
        75% {
            content: '...';
        }
        100% {
            content: '';
        }
    }
`;
exports.ChildrenButtonWithIconContainer = styled_components_1.default.div `
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
`;
